export default __webpack_public_path__ + "static/media/vi.036ba3f5.svg";